// CantieriPage.tsx
import React from "react";
import SideBar from "../Components/SideBar.tsx";
import "./Home.css";
import CalendarMain from "../Components/CalendarMain.tsx";

const CalendarioPage: React.FC = () => {
  return (
    <div style={{ margin: "0", padding: "0", display: "flex", height: "95%" }}>
      <div style={{ margin: "0", padding: "0", width: "5%" }}>
        <SideBar />
      </div>
      <div
        style={{
          margin: "0",
          padding: "0",
          width: "95%",
          minHeight: "100vh",
          paddingBottom: "2rem",
          backgroundColor: "#f7f5f4",
        }}
      >
        <CalendarMain />
      </div>
    </div>
  );
};

export default CalendarioPage;
